import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import {
	PAGE_REACTIONS_SEGMENT_KEY,
	FEED_REACTIONS_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys';

export const PAGE_REACTIONS_METRIC = createPageSegmentLoadMetric({
	key: PAGE_REACTIONS_SEGMENT_KEY,
});

export const FEED_REACTIONS_METRIC = createPageSegmentLoadMetric({
	key: FEED_REACTIONS_SEGMENT_KEY,
});
